import CarrinhoItemModel from "./CarrinhoItemModel";

export class ClearsalePagamentoModel {
	code: string = "";
	sessionID: string = "";
	date: Date = new Date();
	email: string = "";
	b2bB2c: string = "B2C";
	itemValue: number = 0;
	totalValue: number = 0;
	numberOfInstallments: number = 1;
	ip: string = "";
	isGift: boolean = false;
	giftMessage: string = "";
	observation: string = "";
	status: number = 0;
	origin: string = "webapp";
	channelID: string = "mobile";
	reservationDate: string = "";
	country: string = "Brasil";
	nationality: string = "Brasileiro";
	product: number = 4;
	customSla: number = 60;
	billing?: ClearsaleBillingModel = undefined;
	shipping?: ClearsaleShippingModel = undefined;
	payments: ClearsalePagamentoItemModel[] = [];
	items: ClearsaleItemModel[] = [];
}

export class ClearsaleEnderecoModel {
    street: string = "";
    number: string = "";
    additionalInformation: string = "";
    county: string = "";
    city: string = "";
    state: string = "";
    zipcode: string = "";
    country: string = "";
    reference: string = "";
}

export class ClearsaleItemModel {
    code: string = "";
    name: string = "";
    value: number = 0;
    amount: number = 0;

    static toModel(items: CarrinhoItemModel[]): ClearsaleItemModel[] {
        return items.map(i => {
            return {
                amount: i.quantidade,
                code: i.produto.sku,
                name: i.produto.unidade === "GR" ? `${i.produto.nome} ${i.produto.fatorMultiplicacao}g` : i.produto.nome,
                value: i.produto.precoDesconto
            } as ClearsaleItemModel;
        });
    }
}

export class ClearsalePagamentoItemModel {
    sequential: number = 1;
    value: number = 0;
    type: number = 1;
    installments: number = 1;
    interestRate: number = 0;
    interestValue: number = 0;
    currency: number = 986;
    card?: ClearsaleCardModel = undefined;
    address?: ClearsaleEnderecoModel = undefined;
}

export class ClearsaleTelefoneModel {
    type: number = 0;
    ddi: number = 0;
    ddd: number  = 0;
    number: number = 0;
    extension: string = "";
}

export class ClearsaleShippingModel {
    clientID: string = "";
    type: number = 1;
    primaryDocument: string = "";
    name: string = "";
    birthDate: string = "";
    email: string = "";
    gender: string = "M";
    address?: ClearsaleEnderecoModel = undefined;
    phones: ClearsaleTelefoneModel[] = [];
    deliveryType: string = "";
    price: number = 0;
    pickUpStoreDocument: string = "";
}

export class ClearsaleBillingModel {
    clientID: string = "";
    type: number = 1;
    primaryDocument: string = "";
    name: string = "";
    birthDate: string = "";
    email: string = "";
    gender: string = "M";
    address?: ClearsaleEnderecoModel = undefined;
    phones: ClearsaleTelefoneModel[] = [];
}

export class ClearsaleCardModel {
    number: string = "";
    hash: string = "";
    bin: string = "";
    end: string = "";
    type: number = 0;
    validityDate: string = "";
    ownerName: string = "";
    document: string = "";
    nsu: string = "";
}
